import { Box, Text } from "native-base";
import React from "react";

type ToastProps = {
  variant: "success" | "error" | "alert";
  message: string;
};

const Toast = ({ variant, message }: ToastProps) => {
  const colors = {
    success: "success.400",
    error: "error.400",
    alert: "info.400",
  };
  return (
    <Box bg={colors[variant]} p="4" mx="2" rounded="sm" mb={5}>
      <Text fontSize="md" color="white.50" bold>
        {message}
      </Text>
    </Box>
  );
};

export default Toast;
